const HIGHEST_CRITERIA_COLOR = 9;

export function criteriaColorToken(ecNumber: number): string {
  return `--color-criteria-${Math.min(Math.max(ecNumber, 1), HIGHEST_CRITERIA_COLOR)}`;
}

export function toggleCriterionId(
  expandedIds: ReadonlySet<number>,
  criterionId: number,
): ReadonlySet<number> {
  const nextExpandedIds = new Set(expandedIds);

  if (nextExpandedIds.has(criterionId)) {
    nextExpandedIds.delete(criterionId);
  } else {
    nextExpandedIds.add(criterionId);
  }

  return nextExpandedIds;
}
